import {
  CARD_REFUND_STATUS,
  CARD_TRANS_REFUND_STATUS,
  CARD_TRANS_STATUS,
  CARD_TRANSACTION_SHOW_STATUS,
  CARD_TRANSACTION_TYPE
} from "@/constant/Constant";
import RouteConstant from "@/constant/RouteConstant";
import { getCardTransStatusColor } from "@/utils/AssetsUtils";
import { toListItemDateString } from "@/utils/dateUtils";
import {getResourceByMcc, getResourceByMccName, getResourceByMccV2} from "@/utils/utils";
import {Box, Stack, styled, Typography, useTheme} from "@mui/material";
import { useTranslation } from "react-i18next";
import { createSearchParams, useNavigate } from "react-router-dom";
import { CardTransItemType } from "./Transactions";
import RpIcon from "@/components/RpIcon";

const StyledWrapper = styled(Box)(({theme}) => ({
  padding: '14px 0',

  '.icon-wrapper': {
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: theme.palette.background.card,
  },
  '.title-content': {
    padding: '0 10px',
    '.title': {
      fontSize: '14px',
      fontWeight: 500,
      paddingBottom: '4px',
    },
    '.subtitle': {
      fontSize: '11px',
      fontWeight: 400,
    },
  },
  '.right-content': {
    textAlign: 'end',
    '.amount': {
      fontSize: '14px',
      fontWeight: 500,
    },
    '.status': {
      fontSize: '12px',
      fontWeight: 400,
      color: theme.palette.text.disabled,
      '&.warning': {
        color: theme.palette.warning.main,
      },
      '&.success': {
        color: theme.palette.success.main,
      },
      '&.error': {
        color: theme.palette.error.main,
      },

    }
  }
}));

export default function CardTransItem({record, cardType}: { record: CardTransItemType, cardType: any }) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme()
  const _transTile = () => {
    if (!record) return null;
    let icon = getResourceByMccV2(record.mccCode, record.merchantName)


    return <Stack direction={'row'} alignItems={'center'}>
      {
        icon?<div className="icon-wrapper" >
        <img src={icon} className="svg w-full h-full" style={{width:"100%",height:"100%"}}/>
      </div>: <div className="icon-wrapper" >
        <RpIcon color={theme.palette.text.primary} icon="card" size={16} />
      </div>
      }
      <div className="title-content">
        <div className="title">{record.merchantName}</div>
        <div className="subtitle">{`\u2022\u2022\u2022\u2022 ${record.last4}`} {toListItemDateString(record.createTime)}</div>
      </div>
    </Stack>
  }

  const _getStatus = () => {
    if (record.hasRefund == 1 || record.isRefund == 1) {
      return <span className="status error">{t('refund')}</span>;
    }

    if (record.status == CARD_TRANS_STATUS.CLEARED) {
      return t('card_trans_status_cleared');
    } else if (record.status == CARD_TRANS_STATUS.DECLINED) {
      return t('card_trans_status_declined');
    } else {
      return t('card_trans_status_pending');
    }
  }

  const getRefundStatus = () => {
    if (record.refundStatus == CARD_TRANS_REFUND_STATUS.PENDING) {
      return t('card_trans_status_refund_pending');
    } else if (record.refundStatus == CARD_TRANS_REFUND_STATUS.SUCCESS) {
      return t('card_trans_status_refund_success');
    } else if (record.refundStatus == CARD_TRANS_REFUND_STATUS.FAIL) {
      return t('card_trans_status_refund_fail');
    } else if (record.refundStatus == CARD_TRANS_REFUND_STATUS.CANCEL) {
      return t('card_trans_status_refund_cancel');
    } else {
      return t('card_trans_status_refund_wait');
    }
  }

  const _getStatus2 = () => {
    // 转账类型( isTransfer ==true)
    if (record.isTransfer) {
      if (record.isRefund == 1) {
        return t('card_trans_detail_status_refund');
      }
      return t('received')
    }

    // 退款类型 isTransfer=false
    if (record.isRefund == 1 || record.hasRefund == 1) {
      return getRefundStatus();
    }
    // 交易类型 (isTransfer==false 且 isRefund==0 且hasRefund==0)
    if (record.status == CARD_TRANS_STATUS.CLEARED) {
      return t('card_trans_status_cleared');
    } else if (record.status == CARD_TRANS_STATUS.DECLINED) {
      return t('card_trans_status_declined');
    } else if (record.status == CARD_TRANS_STATUS.CLEARED) {
      return t('card_trans_status_canceled');
    } else if (record.status == CARD_TRANS_STATUS.REFUND) {
      return t('card_trans_status_refund');
    } else {
      return t('card_trans_status_pending');
    }
  }

  const _getStatusV2 = () => {
    if (record.transactionType == CARD_TRANSACTION_TYPE.CARD_TRANSACTION) {
      if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.PENDING) {
        return t('card_trans_status_pending')
      } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED) {
        return t('card_trans_status_cleared')
      } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.REVERSAL) {
        return t('card_trans_status_reversal')
      } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED_FULLY_REFUND) {
        return <span>
          <span>{`${t('card_trans_status_fully_refund1')}`}</span>
        <span style={{
          color: theme.palette.warning.main
        }}>({`${t('card_trans_status_fully_refund2')}`})</span>
        </span>
      } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.CLEARED_PARTIAL_REFUND) {
        return <span>
          <span>{`${t('card_trans_status_partial_refund1')}`}</span>
        <span style={{
          color: theme.palette.warning.main
        }}>({`${t('card_trans_status_partial_refund2')}`})</span>
        </span>

      } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.DECLINED) {
        return t('card_trans_status_declined')
      } else if (record.transactionShowStatus == CARD_TRANSACTION_SHOW_STATUS.VOID) {
        return t('card_trans_status_void')
      }
    } else if (record.transactionType == CARD_TRANSACTION_TYPE.REFUND) {
      if (record.refundStatus == CARD_REFUND_STATUS.PENDING) {
        return  t('card_trans_status_refund_pending')
      } else if (record.refundStatus == CARD_REFUND_STATUS.FAIL) {
        return t('card_trans_status_refund_fail')
      } else if (record.refundStatus == CARD_REFUND_STATUS.SUCCESS) {
        return t('card_trans_status_refund_success')
      } else {
        return '';
      }
    } else if (record.transactionType == CARD_TRANSACTION_TYPE.VISA_TRANSFER) {
      if (record.refundStatus == CARD_TRANS_REFUND_STATUS.SUCCESS) {
        return t('card_trans_status_refund_success')
      }
      if (record.refundStatus == CARD_TRANS_REFUND_STATUS.PENDING) {
        return t('card_trans_status_refund_pending')
      }
    }
    // 退款状态，0 没有退款 1 退款处理中 2 退款成功 3 退款失败
  }

  const _getContent = () => {
    return <div>
      <Typography className="amount">
        {record.isRefund !== 1 ? "-" : ""} {record.transactionAmount} {record.transactionCurrencyCode}
      </Typography>
      <div className={`status ${getCardTransStatusColor(record)}`}>
        {_getStatusV2()}
      </div>
    </div>;
  }

  const _toDetail = () => {
    navigate({
      pathname: RouteConstant.CARD_TRANS_DETAIL,
      search: createSearchParams({
        'transactionId': record.transactionId,
        'cardId': record.cardId,
        cardType: cardType,
      }).toString(),
    });
  }

  if (!record) return null;

  return <StyledWrapper onClick={_toDetail}>
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
      {_transTile()}
      <div className="right-content">
        {_getContent()}
      </div>
    </Stack>
  </StyledWrapper>;
}